import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import { filter as filterResource } from "@common/filter";
import { Allocation } from "./allocation";
import styles from "./styles.scss";

function Allocations(props: Props) {
  return (
    <div className={styles.allocations}>
      {props.timeSheet.resources.map((resource, index) => (
        <div
          key={resource.uuid}
          className={classNames(styles.allocation, {
            [styles.even]: index % 2 === 0,
          })}
        >
          <Allocation
            resource={resource}
            filter={props.filter}
            week={props.week}
            project={props.project}
            areDetailsDisplayed={props.areDetailsDisplayed}
            isReloading={props.isReloading}
            showCompletionColumn={props.showCompletionColumn}
            timesheetDeadline={props.timeSheet.timesheetDeadline}
          />
        </div>
      ))}
    </div>
  );
}

export { Allocations };
